/*******************************************************************************
 * Project：
 * Summary:
 *　　 SelectOpinionComponent
 * Remarks:
 *     selectbox component
 * History：
 *      QuangTN            2021/07/26    Create
 ******************************************************************************/
import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { Utility } from '../../utility/utility';
@Component({
  selector: 'app-select-opinion',
  templateUrl: './select-opinion.component.html',
  styleUrls: ['./select-opinion.component.scss']
})
export class SelectOpinionComponent implements OnInit, OnChanges {
  @Input() items: any[];
  @Output() eventSelectValue = new EventEmitter();
  // tslint:disable-next-line: no-output-rename
  @Output('changeOpinion') changeOpinion: EventEmitter<any> = new EventEmitter();
  showDropDown = false;
  disableBtn = false;
  itemSlted: any;
  lstRefItem: any = [];
  constructor(private util: Utility) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (!this.util.isNullOrEmpty(changes) && !this.util.isNullOrEmpty(changes.items)) {
      this.lstRefItem = JSON.parse(JSON.stringify(this.items));
      this.lstRefItem.map(m => m.active = false);
    }
  }

  ngOnInit(): void {
  }
  selected(it: any) {
    this.items.map(m => m.active = false);
    it.active = true;
    this.itemSlted = it.ResultValue;
    this.showDropDown = false;
    this.changeOpinion.emit(this.itemSlted);
  }
  outSelectValue() {
    this.showDropDown = false;
    this.eventSelectValue.emit(this.itemSlted);
    this.changeOpinion.emit(this.itemSlted);
  }
  focusInp() {
    $('#inp-opinion').focus();
  }
  modelChangeFn(value: string) {
    const lstFilter = this.lstRefItem.filter(f => f.ResultValue.includes(value));
    this.items = lstFilter;
  }
}
